import Link from '../Link';
import Image from '../Image';

const propTypes = {
	image: Image.PropTypes,
	link: Link.PropTypes,
};

export default propTypes;
